import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "container overflow-hidden h-full v-full"
};
const _hoisted_2 = {
  class: "flex fixed left-0 right-[10px] top-[70px] h-[calc(100vh-90px)]"
};
const _hoisted_3 = {
  class: "w-64 bg-white shadow-md overflow-y-auto border-r"
};
const _hoisted_4 = {
  key: 0,
  class: "p-4 text-center"
};
const _hoisted_5 = {
  key: 1,
  class: "p-4 text-center text-error"
};
const _hoisted_6 = {
  class: "text-sm"
};
const _hoisted_7 = {
  key: 2
};
const _hoisted_8 = {
  key: 0,
  class: "right mb-4 mr-2"
};
const _hoisted_9 = {
  class: "flex-1 overflow-auto"
};
const _hoisted_10 = {
  key: 2,
  class: "flex items-center justify-center h-full text-gray-400"
};
const _hoisted_11 = {
  class: "text-center"
};
const _hoisted_12 = {
  key: 1,
  class: "container overflow-hidden h-full v-full p-10"
};
import { ref, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import axios from 'axios';
import MetabaseDashboard from '@/components/MetabaseDashboard.vue';
import { useMeStore } from '@/services/UserService/useMeStore';
import LlSecondaryButton from '@/components/LlSecondaryButton.vue';
import { useClerkAiStore } from '@/stores/insights/useClerkAiStore';
import LlTooltip from '@/components/LlTooltip.vue';
import LlListItem from '@/components/LlListItem.vue';
export default {
  __name: 'Dashboard',
  props: {
    alerts: {
      type: Object,
      required: false
    },
    state: {
      type: Object,
      required: false
    },
    stateParams: {
      type: Object,
      required: false
    }
  },
  setup(__props) {
    const props = __props;
    const meStore = useMeStore();
    const {
      me
    } = storeToRefs(meStore);
    const sections = ref([]);
    const selectedDashboardId = ref(null);
    const dashboardsById = ref(new Map());
    const loading = ref(true);
    const error = ref(null);
    const showBanner = ref(true);
    const clerkAi = useClerkAiStore();
    const toggleChat = () => clerkAi.toggle();
    const dismissBanner = () => {
      showBanner.value = false;
    };
    const findDashboardByTag = (dashboards, routeTag) => {
      if (!routeTag) {
        return null;
      }
      return dashboards.find(dashboard => dashboard.tag === routeTag) || null;
    };
    const loadDashboards = async () => {
      try {
        loading.value = true;
        error.value = null;
        const response = await axios.get('/insights/dashboards?group=insights');
        const dashboards = response.data;
        dashboardsById.value = new Map(dashboards.map(dashboard => [dashboard.id, dashboard]));

        // Group dashboards by sections ("section" property)
        sections.value = [];
        dashboards.forEach(dashboard => {
          const section = dashboard.section?.toUpperCase() || '';
          let sectionObj = sections.value.find(s => s.header === section);
          if (!sectionObj) {
            sectionObj = {
              header: section,
              dashboards: []
            };
            sections.value.push(sectionObj);
          }
          sectionObj.dashboards.push(dashboard);
        });
        const routeTag = props.stateParams?.tag;

        // Select the tagged dashboard if present, otherwise default to the first dashboard.
        if (dashboards && dashboards.length > 0) {
          const taggedDashboard = findDashboardByTag(dashboards, routeTag);
          selectedDashboardId.value = taggedDashboard?.id || dashboards[0].id;
        }
      } catch (err) {
        error.value = err?.response?.data?.message || err.message || 'Failed to load dashboards';
        if (props.alerts) {
          props.alerts.error(error.value);
        }
      } finally {
        loading.value = false;
      }
    };
    const syncUrlWithDashboardTag = dashboard => {
      if (!props.state?.go) {
        return;
      }
      const nextTag = dashboard?.tag || null;
      const currentTag = props.stateParams?.tag || null;
      if (nextTag === currentTag) {
        return;
      }
      props.state.go('dashboard', {
        tag: nextTag
      }, {
        notify: false,
        reload: false
      });
    };
    const selectDashboard = dashboardOrId => {
      const dashboard = typeof dashboardOrId === 'object' && dashboardOrId !== null ? dashboardOrId : dashboardsById.value.get(dashboardOrId);
      if (!dashboard) {
        return;
      }
      selectedDashboardId.value = dashboard.id;
      syncUrlWithDashboardTag(dashboard);
    };
    onMounted(() => {
      loadDashboards();
    });
    return (_ctx, _cache) => {
      const _component_v_progress_circular = _resolveComponent("v-progress-circular");
      const _component_v_icon = _resolveComponent("v-icon");
      const _component_v_list_subheader = _resolveComponent("v-list-subheader");
      const _component_v_divider = _resolveComponent("v-divider");
      const _component_v_list = _resolveComponent("v-list");
      const _component_v_alert = _resolveComponent("v-alert");
      return _unref(me)?.permissions.reports.viewDashboards ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_v_progress_circular, {
        indeterminate: "",
        color: "primary",
        size: "32"
      })])) : error.value ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_v_icon, {
        color: "error",
        class: "mb-2"
      }, {
        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [_createTextVNode("mdi-alert-circle", -1)]))]),
        _: 1
      }), _createElementVNode("div", _hoisted_6, _toDisplayString(error.value), 1)])) : (_openBlock(), _createElementBlock("div", _hoisted_7, [!_unref(me).features.dashboard && _unref(me)?.permissions.reports.chat ? (_openBlock(), _createElementBlock("div", _hoisted_8, [_createVNode(LlSecondaryButton, {
        size: "small",
        color: "primary",
        variant: "outlined",
        class: "w-full sm:w-auto",
        "prepend-icon": "mdi-message-question-outline",
        onClick: _cache[0] || (_cache[0] = $event => toggleChat())
      }, {
        default: _withCtx(() => [...(_cache[2] || (_cache[2] = [_createTextVNode(" ClerkAI ", -1)]))]),
        _: 1
      })])) : _createCommentVNode("", true), _createVNode(_component_v_list, {
        density: "compact",
        class: "clear"
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sections.value, section => {
          return _openBlock(), _createElementBlock(_Fragment, {
            key: section.header
          }, [section.header ? (_openBlock(), _createBlock(_component_v_list_subheader, {
            key: 0,
            class: "mt-5"
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(section.header), 1)]),
            _: 2
          }, 1024)) : (_openBlock(), _createBlock(_component_v_divider, {
            key: 1
          })), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.dashboards, dashboard => {
            return _openBlock(), _createBlock(LlListItem, {
              key: dashboard.id,
              nav: "",
              current: selectedDashboardId.value === dashboard.id,
              class: "mb-0.5 hover:bg-gray-50",
              onClick: $event => selectDashboard(dashboard)
            }, {
              default: _withCtx(() => [_createTextVNode(_toDisplayString(dashboard.name) + " ", 1), dashboard.info ? (_openBlock(), _createBlock(LlTooltip, {
                key: 0,
                icon: "help",
                class: "ml-2"
              }, {
                default: _withCtx(() => [_createTextVNode(_toDisplayString(dashboard.info), 1)]),
                _: 2
              }, 1024)) : _createCommentVNode("", true)]),
              _: 2
            }, 1032, ["current", "onClick"]);
          }), 128))], 64);
        }), 128))]),
        _: 1
      })]))]), _createElementVNode("div", _hoisted_9, [showBanner.value ? (_openBlock(), _createBlock(_component_v_alert, {
        key: 0,
        type: "info",
        variant: "tonal",
        density: "compact",
        closable: "",
        "onClick:close": dismissBanner,
        class: "ma-2 text-sm"
      }, {
        text: _withCtx(() => [...(_cache[3] || (_cache[3] = [_createTextVNode(" This page is a pre-release feature enabled for evaluation in your account. It may not be available in your current plan in the future. ", -1)]))]),
        _: 1
      })) : _createCommentVNode("", true), selectedDashboardId.value ? (_openBlock(), _createBlock(MetabaseDashboard, {
        key: 1,
        dashboardId: selectedDashboardId.value,
        alerts: __props.alerts
      }, null, 8, ["dashboardId", "alerts"])) : (_openBlock(), _createElementBlock("div", _hoisted_10, [_createElementVNode("div", _hoisted_11, [_createVNode(_component_v_icon, {
        size: "64",
        color: "grey-lighten-1"
      }, {
        default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("mdi-view-dashboard-outline", -1)]))]),
        _: 1
      }), _cache[5] || (_cache[5] = _createElementVNode("div", {
        class: "mt-4 text-lg"
      }, "Select a dashboard to view", -1))])]))])])])) : (_openBlock(), _createElementBlock("div", _hoisted_12, [...(_cache[6] || (_cache[6] = [_createElementVNode("p", null, " This page is only available for users with permissions to view dashboards. ", -1), _createElementVNode("p", null, " By default this follows the permissions set by your firm for access to \"Other revenue reports\" ", -1)]))]));
    };
  }
};